import { CasWideTextFilter } from 'src/compass/shared/components';

/*
  The search filter on every tab of Risk Management > Customers (Customers, Touchpoints,
  Handoffs, Unassigned). All four list Utilities/EntityTouchpoint, whose SearchName
  (EntityTouchpointListRequestBo) matches the customer's name, its contacts' names, and
  its accounts' names - so the label says so, since a row can match on an account the
  grid never shows. It matches exactly as the page's search box does (a substring, or a
  5 digit account number), so it takes any character the box does. One definition keeps
  the four tabs from drifting apart.
*/
const customerSearchFilter = {
  type: 'component',
  name: 'searchName',
  label: 'Search Name, Contacts, Accounts',
  component: CasWideTextFilter,
  componentProps: {
    // CasTable's label-based estimate (8px a character) would leave this label ~3px to spare.
    minWidth: 264,
    // This search scans names three ways plus the paging count, so it waits for a
    // pause in typing rather than firing per keystroke - and longer than the app
    // default, which split normal typing into several requests here.
    debounce: 400,
  },
};

export default customerSearchFilter;
